var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmsFeatureAblaufgrafikDesktopStep1Rgb = function SvgSmsFeatureAblaufgrafikDesktopStep1Rgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 180",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "schrift"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.2,173.8H198.3v-4.5c0-14.2-9.9-25.8-22.1-25.8h-.5c-2.6-16-14.6-28.1-29-28.1a24.7,24.7,0,0,0-8.6,1.5C131.4,101.5,117.7,91,101.9,91s-29,10.2-35.8,25.2a24.8,24.8,0,0,0-6.1-.7c-14.5,0-26.6,12.3-29.1,28.4a22,22,0,0,0-3.6-.4c-12.2,0-22.1,11.5-22.1,25.8v4.5Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,173.8H265.9v-3.7A22.1,22.1,0,0,0,243.8,148h-.5a29.6,29.6,0,0,0-29.1-24.1,27.1,27.1,0,0,0-8.6,1.3,40.6,40.6,0,0,0-72.1-.6,30.8,30.8,0,0,0-6.1-.6,29.5,29.5,0,0,0-29.1,24.4,21.9,21.9,0,0,0-3.6-.3,22.1,22.1,0,0,0-22.1,22.1v3.6Z",
    style: {
      fill: "var(--ca-primary-color-lighter, #5fcced)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,173.8H296.4V171c0-8.9-7.9-16-17.6-16h-.4c-2-9.9-11.6-17.5-23.1-17.5a24.8,24.8,0,0,0-6.8.9c-5.3-9.6-16.2-16.1-28.8-16.1s-23.1,6.3-28.5,15.6a26.1,26.1,0,0,0-4.8-.5c-11.6,0-21.2,7.6-23.1,17.7l-2.9-.2c-9.7,0-17.6,7.2-17.6,16v2.9Z",
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.4,113h-5.8v-1.8h5.8Zm-10.8,0h-6.1v-1.8h6.1Zm-11.1,0H91.4v-1.8h6.1Zm-11.1,0H80.3v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H58.2v-1.8h6.1Zm-11.1,0H47.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H25v-1.8h6.1Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3,108h-5.9v-1.8h5.9Zm-10.9,0h-6.1v-1.8h6.1Zm-11.1,0H91.2v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H69.1v-1.8h6.1Zm-11.1,0H58v-1.8h6.1ZM53,108H47v-1.8h6Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,118.4h-5.7v-1.8h5.7Zm-10.7,0h-6.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H80.2v-1.8h6.1Zm-11.1,0H69.1v-1.8h6.1Zm-11.1,0h-6v-1.8h6Zm-11,0H47v-1.8h6.1Zm-11.1,0H35.9v-1.8H42Zm-11.1,0h-6v-1.8h6Zm-11,0H13.8v-1.8h6.1Zm-11.1,0H2.7v-1.8H8.8Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.4,111.2h5.9V113h-5.9Zm10.9,0h6V113h-6Zm11,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6V113h-6Zm11,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6.1V113h-6.1Zm11.1,0h6V113h-6Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,106.3h5.9v1.8h-5.9Zm10.9,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.7,116.6h5.7v1.8h-5.7Zm10.7,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0h6.1v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8h-6.1Zm11.1,0H272v1.8h-6.1Zm11.1,0h6v1.8h-6Zm11,0h6.1v1.8H288Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.7,
    y: 37.6,
    width: 160.3,
    height: 124.95,
    rx: 8.5,
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,44.3a2.1,2.1,0,1,0,2,2.1A2.1,2.1,0,0,0,206.2,44.3Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,44.3a2.1,2.1,0,1,0,2,2.1A2.1,2.1,0,0,0,212.1,44.3Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 46.4,
    r: 2,
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.9,
    y1: 53,
    x2: 228.5,
    y2: 53,
    style: {
      fill: "none",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.9,
    y: 105.1,
    width: 63.7,
    height: 10.49,
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-base, #009dd4)",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.8,110.3a5.8,5.8,0,0,1-.4,2.7,1.7,1.7,0,0,1-3,0,7.6,7.6,0,0,1-.4-2.7,5.9,5.9,0,0,1,.5-2.7,1.5,1.5,0,0,1,1.4-.9,1.6,1.6,0,0,1,1.5.8A6.6,6.6,0,0,1,87.8,110.3Zm-2.5,0a9.8,9.8,0,0,0,.1,2c.1.3.3.5.5.5l.4-.2a4.5,4.5,0,0,0,.2-.8v-1.5a9.8,9.8,0,0,0-.1-2c-.1-.3-.3-.5-.5-.5s-.4.2-.5.5A9.8,9.8,0,0,0,85.3,110.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,113.8H90.4v-5.6l-.2.3a5.7,5.7,0,0,0-.8.8l-.8-.8,1.9-1.7h1.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,113.8H93v-1l1.3-1.7L95,110l.3-.7c0-.2.1-.4.1-.6a.8.8,0,0,0-.2-.6c-.1-.2-.3-.2-.5-.2h-.5l-.5.5-.7-.8a3.2,3.2,0,0,1,.9-.8l.9-.2a2.2,2.2,0,0,1,1.4.5,2.1,2.1,0,0,1,.4,1.4,2.2,2.2,0,0,1-.1.8,2.5,2.5,0,0,1-.2.7l-.5.7a11.2,11.2,0,0,1-1.3,1.8h2.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2,108.4a2.1,2.1,0,0,1-.4,1.1,1.5,1.5,0,0,1-.9.6h0a1.1,1.1,0,0,1,1,.5,1.2,1.2,0,0,1,.4,1.1,2,2,0,0,1-.6,1.5,2.1,2.1,0,0,1-1.6.6,3.5,3.5,0,0,1-1.6-.3v-1.2l.7.3h.7l.8-.2a1.2,1.2,0,0,0,.3-.9c0-.7-.4-1-1.3-1h-.4v-1h.4l.9-.2a1.1,1.1,0,0,0,.3-.8,1.4,1.4,0,0,0-.2-.7.8.8,0,0,0-.6-.2,1.6,1.6,0,0,0-1,.5l-.6-.9a2.9,2.9,0,0,1,1.8-.7,2.2,2.2,0,0,1,1.4.5A1.7,1.7,0,0,1,101.2,108.4Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.5,112.3h-.7v1.5h-1.2v-1.5h-2.3v-1l2.1-4.5h1.4v4.5h.7Zm-1.9-1v-2.8h0a3,3,0,0,1-.4,1l-.8,1.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,109.4a1.5,1.5,0,0,1,1.3.6,2.1,2.1,0,0,1,.5,1.5,2.8,2.8,0,0,1-.6,1.8,2.1,2.1,0,0,1-1.6.6,2.4,2.4,0,0,1-1.5-.4v-1.2l.6.3.7.2c.7,0,1-.4,1-1.2s-.3-1.1-.9-1.1h-.9l-.4-.3.2-3.5h3V108h-1.9v1.5Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5,110.8a5.3,5.3,0,0,1,.7-3.1,2.3,2.3,0,0,1,2-1h.8v1.1h-.7l-.9.2a1.6,1.6,0,0,0-.5.8,3.9,3.9,0,0,0-.2,1.3h0a1,1,0,0,1,.5-.6l.7-.2a1.1,1.1,0,0,1,1,.6,2.4,2.4,0,0,1,.4,1.6,2.3,2.3,0,0,1-.5,1.7,1.5,1.5,0,0,1-1.4.7,1.6,1.6,0,0,1-1.4-.8A4.6,4.6,0,0,1,113.5,110.8Zm1.9,2a.5.5,0,0,0,.5-.3,2.5,2.5,0,0,0,.2-1,2.4,2.4,0,0,0-.2-.9.5.5,0,0,0-.5-.3.5.5,0,0,0-.4.3,1.9,1.9,0,0,0-.2.8,2.5,2.5,0,0,0,.2,1C115.1,112.7,115.2,112.8,115.4,112.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,113.8l2-5.8h-2.4v-1.2h3.7v.9l-1.9,6.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,106.7a1.9,1.9,0,0,1,1.3.5,1.7,1.7,0,0,1,.5,1.3,1.1,1.1,0,0,1-.3.8,1.8,1.8,0,0,1-.7.8,2.2,2.2,0,0,1,.8.9,1.7,1.7,0,0,1,.3,1,1.7,1.7,0,0,1-1.9,1.9,2,2,0,0,1-1.4-.5,1.6,1.6,0,0,1-.5-1.4,1.6,1.6,0,0,1,.2-1l.8-.8-.7-.8a2.9,2.9,0,0,1-.2-.9,1.7,1.7,0,0,1,.5-1.3A1.9,1.9,0,0,1,126.9,106.7Zm-.7,5.3a1.1,1.1,0,0,0,.2.6.5.5,0,0,0,.5.3.5.5,0,0,0,.5-.3,1.1,1.1,0,0,0,.2-.6,1.4,1.4,0,0,0-.2-.6,1.3,1.3,0,0,0-.5-.6h-.1l-.4.5A1.1,1.1,0,0,0,126.2,112Zm.7-4.3a.5.5,0,0,0-.4.2,1.4,1.4,0,0,0-.2.6c0,.2.1.4.1.6l.5.4.4-.4a1.3,1.3,0,0,0,.1-.6C127.4,108,127.2,107.7,126.9,107.7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3,109.9c0,2.6-.9,4-2.7,4h-.8v-1.1h.6a1.7,1.7,0,0,0,1.3-.5,4,4,0,0,0,.4-1.8h0a1,1,0,0,1-.5.6.7.7,0,0,1-.6.2,1.3,1.3,0,0,1-1.1-.5,2.7,2.7,0,0,1-.4-1.6,2.4,2.4,0,0,1,.5-1.8,1.7,1.7,0,0,1,1.3-.7,1.8,1.8,0,0,1,1.5.8A5.4,5.4,0,0,1,133.3,109.9Zm-1.9-2.1a.5.5,0,0,0-.5.3,3,3,0,0,0-.2,1,2,2,0,0,0,.2.9c.1.2.2.3.4.3a.5.5,0,0,0,.5-.3,1.9,1.9,0,0,0,.2-.7,3.6,3.6,0,0,0-.2-1.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,110.3a5.8,5.8,0,0,1-.4,2.7,1.7,1.7,0,0,1-3,0,7.6,7.6,0,0,1-.4-2.7,5.9,5.9,0,0,1,.5-2.7,1.5,1.5,0,0,1,1.4-.9,1.6,1.6,0,0,1,1.5.8A6.6,6.6,0,0,1,137.8,110.3Zm-2.5,0a9.8,9.8,0,0,0,.1,2c.1.3.3.5.5.5l.4-.2a4.5,4.5,0,0,0,.2-.8v-1.5a9.8,9.8,0,0,0-.1-2c-.1-.3-.3-.5-.5-.5s-.4.2-.5.5A9.8,9.8,0,0,0,135.3,110.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,113.8h-1.2v-5.6l-.2.3-.8.8-.8-.8,1.9-1.7h1.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,130.7H81.9a1.5,1.5,0,0,1-1.5-1.5v-7.1a1.5,1.5,0,0,1,1.5-1.5h59.7a1.5,1.5,0,0,1,1.5,1.5v7.1A1.4,1.4,0,0,1,141.6,130.7Z",
    style: {
      fill: "var(--ca-primary-color-base, #009dd4)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 104.8,
    width: 60,
    height: 27.57,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1,125.8a4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7l-1-1.7a4,4,0,0,0-5-1.8,4,4,0,0,0-1.9,5.7l-8.6-14.5a3.9,3.9,0,1,0-6.8,4l15.6,26.3a.4.4,0,0,1-.6.6l-5.9-3.5a4,4,0,0,0-5.4,1.1,3.9,3.9,0,0,0,1.1,5.4,99.7,99.7,0,0,0,11.8,6.6c6.5,2.9,13.9,6.5,20.1,4.5,10.2-3.4,10.6-9.8,10.6-13a44.9,44.9,0,0,0-5.4-19.4l-3.7-6.3A4.1,4.1,0,0,0,169.1,125.8Z",
    style: {
      fill: "#fff",
      stroke: "var(--ca-primary-color-light, #00a2d4)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 58.4,
    width: 139.4,
    height: 7.15,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.5,
    y: 69.1,
    width: 139.4,
    height: 31.39,
    style: {
      fill: "var(--ca-primary-color-lightest, #96e3fa)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,11.8H37.1V10H46v1.8H42.6v10H40.5Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,10H55v1.8H50v3h4.2v1.7H50V20h5.2v1.8H47.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,10h2.1V20h4.9v1.8h-7Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,10h7.1v1.8h-5v3H73v1.7H68.7V20h5.2v1.8H66.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3,10h7.1v1.8h-5v3.3h4.3v1.8H78.4v4.9H76.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,15.8c0-3.8,2.1-6,5.2-6s5.2,2.2,5.2,6S93,22,89.9,22,84.7,19.7,84.7,15.8Zm8.2,0c0-2.6-1.1-4.2-3-4.2s-3,1.6-3,4.2,1.1,4.4,3,4.4S92.9,18.5,92.9,15.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5,10h2.1l3.7,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V10h2V21.8h-2.2l-3.6-6.6-1.2-2.6h-.1c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3,10h2.1l3.7,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V10h2V21.8h-2.2l-3.6-6.6-1.2-2.6H111c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,16.6V10h2.1v6.8c0,2.5,1,3.4,2.4,3.4s2.4-.9,2.4-3.4V10h2v6.6c0,3.9-1.7,5.4-4.4,5.4S121,20.5,121,16.6Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,10h2.3l2.1,5.8c.3.7.5,1.5.8,2.3h0c.3-.8.5-1.6.8-2.3l2-5.8h2.4V21.8h-1.9V16.4c0-1.1.1-2.7.2-3.8h0l-1,2.8-1.9,5.3h-1.3l-1.9-5.3-.9-2.8h-.1c.1,1.1.3,2.7.3,3.8v5.4h-1.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,10h2.3l2.1,5.8c.3.7.5,1.5.8,2.3h0c.3-.8.5-1.6.8-2.3l2-5.8h2.4V21.8h-1.9V16.4c0-1.1.1-2.7.2-3.8h0l-1,2.8-1.9,5.3h-1.3l-1.9-5.3-.9-2.8h-.1c.1,1.1.3,2.7.3,3.8v5.4h-1.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,10h7.1v1.8h-5v3H166v1.7h-4.2V20H167v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,10h3.9c2.5,0,4.4.9,4.4,3.5a3.4,3.4,0,0,1-2.4,3.4l2.8,4.9h-2.3l-2.5-4.6h-1.8v4.6h-2.1Zm3.7,5.5c1.6,0,2.5-.7,2.5-2s-.9-1.8-2.5-1.8h-1.6v3.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.6,10h7.1v1.8h-5v3h4.2v1.7h-4.2V20h5.2v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,10h2.1V21.8h-2.1Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4,10h2.1l3.7,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V10h2V21.8h-2.1l-3.7-6.6-1.2-2.6h-.1c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.6,15.9c0-3.8,2.4-6.1,5.5-6.1a4.7,4.7,0,0,1,3.6,1.5l-1.1,1.3a3.5,3.5,0,0,0-2.4-1c-2.1,0-3.5,1.6-3.5,4.3s1.3,4.3,3.6,4.3a2.9,2.9,0,0,0,1.7-.5V17.1h-2.2V15.4h4.1v5.2a5.5,5.5,0,0,1-3.8,1.4C211.9,22,209.6,19.8,209.6,15.9Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.5,10h7.1v1.8h-5v3h4.2v1.7h-4.2V20h5.2v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2,10h3.7c2.5,0,4.3.7,4.3,2.9a2.9,2.9,0,0,1-1.7,2.6h0a2.7,2.7,0,0,1,2.3,2.8c0,2.4-2,3.5-4.6,3.5h-4Zm3.6,4.9c1.6,0,2.3-.7,2.3-1.7s-.8-1.6-2.3-1.6h-1.5v3.3Zm.2,5.3c1.8,0,2.7-.7,2.7-2s-.9-1.8-2.7-1.8h-1.7v3.8Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.9,10H249v1.8h-5v3h4.2v1.7H244V20h5.2v1.8h-7.3Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,10h2.2l3.6,6.6,1.2,2.5h.1c-.1-1.2-.3-2.7-.3-4V10h2V21.8h-2.1l-3.7-6.6-1.2-2.6h-.1c.1,1.3.3,2.7.3,4v5.2h-2Z",
    style: {
      fill: "var(--ca-primary-color-light, #00a2d4)"
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmsFeatureAblaufgrafikDesktopStep1Rgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms-feature-ablaufgrafik-desktop-step1-rgb.b731ec463703634c34f37b4b5769023f.svg";